export default {
    // advertising.vue
    advertising_show: 'Show' /*Display status*/,
    advertising_hide: 'Hide' /*Hidden status*/,
    advertising_content_management: 'Content Management' /*Content management button*/,
    advertising_position: 'Advertising Position' /*Column title for advertising position*/,
    advertising_views: 'Page Views' /*Column title for page views*/,

    // banner.vue
    banner_add: 'Add New' /*Add new button*/,
    banner_query: 'Query' /*Query button (commented out)*/,
    banner_edit: 'Edit' /*Edit button*/,
    banner_delete: 'Delete' /*Delete button*/,
    banner_confirm_delete: 'Are you sure you want to delete this banner?' /*Delete confirmation prompt*/,
    banner_confirm: 'Confirm' /*Confirm button in confirmation dialog*/,
    banner_cancel: 'Cancel' /*Cancel button in confirmation dialog*/,
    banner_title: 'Title' /*Column title for title*/,
    banner_image: 'Image' /*Column title for image*/,
    banner_create_time: 'Creation Time' /*Column title for creation time*/,
    banner_operation: 'Operation' /*Column title for operation*/,
    banner_title_required: 'Please enter the title',
    banner_title_vice_required: 'Please enter the subtitle',
    banner_title_vice: 'Subtitle' /*Column title for subtitle*/,
    banner_image_scale: 'Thumbnail' /*Column title for thumbnail*/,

    // info.vue
    info_clear_cache: 'Clear Cache' /*Clear cache button*/,
    info_loading: 'Loading...' /*Loading prompt*/,
    info_website_cache: 'Micro Website Homepage Cache' /*Micro website homepage cache label*/,
    info_views_count: 'View Count' /*Page views label*/,
    info_share_count: 'Share Count' /*Share volume label*/,
    info_view_website: 'View Micro Website' /*Link text to view the micro website*/,
    info_website_status: 'Micro Website Status' /*Micro website status label*/,
    info_website_title: 'Micro Website Title' /*Micro website title label*/,
    info_website_title_required: 'Please enter the micro website title' /*Input prompt for micro website title*/,
    info_copyright: 'Bottom Copyright Notice' /*Bottom copyright notice label*/,
    info_copyright_required: 'Please enter the bottom copyright notice' /*Input prompt for bottom copyright notice*/,
    info_countdown: 'Enable Countdown' /*Countdown switch label*/,
    info_countdown_type: 'Countdown Type' /*Countdown type label*/,
    info_countdown_bg_color: 'Countdown Background Color' /*Countdown background color label*/,
    info_countdown_font_color: 'Countdown Text Color' /*Countdown text color label*/,
    info_welcome_page: 'Show Welcome Page' /*Whether to show the welcome page label*/,
    info_show_jump_button: 'Show Jump Button' /*Whether to show the jump button label*/,
    info_welcome_image: 'Welcome Page Image' /*Welcome page image label*/,
    info_jump_link: 'Welcome Page Jump Link' /*Welcome page jump link label*/,
    info_show_countdown_time: 'Show Jump Time' /*Whether to show the jump time label*/,
    info_stay_time: 'Page Stay Time' /*Page stay time label*/,
    info_show_footer_pc: 'Show Homepage Footer (PC)' /*Whether to show the homepage footer label*/,
    info_show_signup_bar: 'Show Sign-up Bar on Secondary Pages' /*Whether to show the sign-up bar on secondary pages label*/,
    info_show_homepage_bg: 'Show Homepage Background Image on Secondary Pages' /*Whether to show the homepage background image on secondary pages label*/,
    info_background_music: 'Enable Background Music' /*Whether to enable background music label*/,
    info_audio_file: 'Audio File' /*Audio file label*/,
    info_audio_file_tips: 'Supported extensions: .mp3, .m4a' /*Audio file prompt*/,
    info_upload_audio: 'Upload Audio' /*Upload audio button*/,
    info_submit: 'Submit Now' /*Submit button*/,
    info_clear_cache_tips: 'After updating the micro website content, if the web page data does not change, please click to clear the cache' /*Clear cache prompt information*/,
    info_upload_image: 'Please upload an image' /*Upload image prompt*/,
    info_image_size_tips:
        'Recommended size: 1080*1700. Supports JPG, GIF, PNG image files, and the file size should be less than 1M. (Note: This image is displayed before the homepage is loaded)' /*Image size prompt*/,
    info_input_link: 'Please enter the jump link' /*Jump link input prompt*/,
    info_http_link_tips: 'Please enter a link starting with http:// or https://' /*Link format prompt*/,
    info_unit_seconds: 'Unit: seconds' /*Unit prompt*/,
    info_open: 'Enable' /*Enable option*/,
    info_close: 'Disable' /*Disable option*/,
    open: 'Activate',
    no_open: 'Do not activate',
    info_display_auto_redirect: 'Enable - Automatic Website Redirect' /*Enable - Automatic website redirect option*/,
    info_display_no_auto_redirect: 'Enable - No Automatic Website Redirect' /*Enable - No automatic website redirect option*/,
    info_show: 'Show' /*Show option*/,
    info_hide: 'Hide' /*Hide option*/,
    info_enable: 'Activate' /*Activate option*/,
    info_disable: 'Do not activate' /*Do not activate option*/,

    // nav-list.vue
    nav_list_add: 'Add New' /*Add new button*/,
    nav_list_add_sub: 'Add Sub-column' /*Add sub-column button*/,
    nav_list_edit: 'Edit' /*Edit button*/,
    nav_list_manage_content: 'Manage Content' /*Manage content button*/,
    nav_list_delete: 'Delete' /*Delete button*/,
    nav_list_confirm_delete: 'Are you sure you want to delete this column?' /*Delete confirmation prompt*/,
    nav_list_confirm: 'Confirm' /*Confirm button in confirmation dialog*/,
    nav_list_cancel: 'Cancel' /*Cancel button in confirmation dialog*/,
    nav_list_menu_name: 'Navigation Menu Name' /*Column title for navigation menu name*/,
    nav_list_icon: 'Icon' /*Column title for icon*/,
    nav_list_column_type: 'Column Type' /*Column title for column type*/,
    nav_list_hidden: 'Hidden Status' /*Column title for hidden status*/,
    nav_list_sub_items: 'Add Sub-columns' /*Column title for adding sub-columns in operation column*/,
    nav_list_views: 'Page Views' /*Column title for page views*/,
    nav_list_operation: 'Operation' /*Column title for operation*/,
    nav_list_display: 'Show' /*Display status*/,
    nav_list_hide: 'Hide' /*Hidden status*/,
    nav_list_not_supported: 'This type is not supported yet' /*Prompt message for unsupported type*/,

    // share.vue
    share_link: 'Share Link' /*Label for share link input box*/,
    please_input_share_link: 'Please enter the share link',
    share_copy: 'Copy' /*Copy link button*/,
    share_submit: 'Submit Now' /*Submit button*/,
    share_enter_link: 'Please enter the share link' /*Input validation prompt*/,
    share_wechat_title: 'WeChat Share Title' /*Label for WeChat share title input box*/,
    share_wechat_desc: 'WeChat Share Description' /*Label for WeChat share description input box*/,
    share_default_desc: 'If the share description is empty, the live introduction will be displayed by default. To insert a new line, please enter \n' /*Share description prompt*/,
    share_warning: 'Note: Do not copy and paste from elsewhere, otherwise the share will fail!' /*Input warning*/,
    share_wechat_nickname: 'WeChat Nickname' /*Example text*/,
    share_qrcode: 'Scan the QR code to share the website' /*QR code description*/,
    share_qrcode_generator: 'QR Code Generator' /*Link text for QR code generator*/,
    share_mini_program: 'Scan the mini-program code to share the website' /*Mini-program code description*/,
    share_friend_preview: 'Friend Share Preview' /*Title for friend share preview*/,
    share_circle_preview: 'Moments Preview' /*Title for Moments preview*/,
    please_input_share_content: 'Please enter the share content',
    please_input_share_description: 'Please enter the share description',
    if_the_share_description_is_empty_the_default_display_live_introduction:
        'If the share description is empty, the live introduction will be displayed by default. To insert a new line, please enter \n',
    note_do_not_copy_and_paste_from_elsewhere_otherwise_the_share_will_fail: 'Note: Do not copy and paste from elsewhere, otherwise the share will fail!',
    // style.vue
    style_template: 'Template Selection' /*Label for template selection input box*/,
    style_home_bg_color: 'Homepage Background Color' /*Homepage background color setting*/,
    style_home_bg_image: 'Homepage Background Image' /*Homepage background image upload*/,
    style_nav_icon_color: 'Navigation Icon Text Color' /*Navigation icon text color setting*/,
    style_nav_font_size: 'Navigation Font Size' /*Navigation font size setting*/,
    style_subnav_display: 'Secondary Column Display Style' /*Secondary column display style*/,
    style_nav_bold: 'Navigation Font Boldness' /*Navigation font boldness setting*/,
    bold: 'Bold',
    not_bold: 'Not Bold',
    style_subnav_bg_color: 'Secondary Page Navigation Background Color' /*Secondary page navigation background color setting*/,
    style_subnav_font_color: 'Secondary Page Navigation Font Color' /*Secondary page navigation font color setting*/,
    style_home_advert_color: 'Homepage Text Advertisement Background Color' /*Homepage text advertisement background color setting*/,
    style_save: 'Save' /*Save button*/,
    style_clear: 'Clear' /*Clear image button*/,
    style_select_template: 'Please select a template' /*Template selection validation prompt*/,
    style_home_bg_required: 'The homepage background color cannot be empty' /*Color selection validation prompt*/,
    style_advert_color_required: 'The homepage text advertisement background color cannot be empty' /*Color selection validation prompt*/,
    style_nav_icon_color_required: 'The navigation icon text color cannot be empty' /*Color selection validation prompt*/,
    style_subnav_bg_required: 'The secondary page navigation background color cannot be empty' /*Color selection validation prompt*/,
    style_subnav_font_required: 'The secondary page navigation font color cannot be empty' /*Color selection validation prompt*/,
    style_image_format_tips: "Supports JPG, GIF, PNG image files. If you don't need a background image, please clear the supported extensions (Recommended size: 1080 × 1920)" /*Image upload prompt*/,
    style_image_only: 'You can only upload image files' /*File type validation prompt*/,

    // Common
    common_yes: 'Yes' /*General yes option*/,
    common_no: 'No' /*General no option*/,
    please_upload_remittance_certificate: 'Please upload the remittance certificate',
    welcome_page_image_required: 'Please upload an image' /*Welcome page image upload validation prompt*/,
    adv_edit: {
        title: 'Edit Advertisement',
        add_adv: 'Add Advertisement',
        adv_title: 'Text Carousel Content',
        adv_title_required: 'Please enter the text carousel content',
        adv_title_tips: 'Control the number of characters to about 25',
        adv_url: 'Jump Address',
        adv_url_required: 'Please enter the link address',
        adv_url_tips: 'The format should start with http:// or https://. If not filled in, there will be no jump!',
        adv_add: 'Add Advertisement'
    },
    adv_list: {
        title: 'Advertisement List',
        add_adv: 'Create New Advertisement',
        adv_title: 'Title',
        adv_title_vice: 'Subtitle',
        adv_click: 'Click Volume',
        adv_status: 'Status',
        adv_create_time: 'Creation Time',
        adv_create_user: 'Creator',
        adv_sort_success: 'Sorting successful',
        adv_delete_confirm: 'Are you sure you want to delete this advertisement?'
    },
    banner_info: {
        title: 'Title',
        title_required: 'Please enter the title',
        image: 'Focus Image',
        image_required: 'Please upload an image',
        image_tips: 'Supports JPG, GIF, PNG image files. Recommended size: 900*500',
        image_scale: 'Thumbnail',
        image_scale_required: 'Please upload a thumbnail',
        image_scale_tips: 'Supports JPG, GIF, PNG image files. Recommended size: 900*500',
        upload_image: 'Upload Image',
        clear_image: 'Clear',
        link: 'Link',
        link_required: 'Please enter a link starting with http:// or https://',
        sort: 'Sorting',
        submit: 'Submit Now'
    },
    guest_info: {
        name: 'Name',
        name_required: 'Please enter the name',
        photo: 'Photo',
        photo_required: 'Please upload a photo',
        photo_tips: '150*150px. Supports JPG, GIF, PNG image files. Files larger than 500K will be automatically compressed',
        upload_photo: 'Upload Photo',
        clear_photo: 'Clear',
        company: 'Company',
        title: 'Title',
        position: 'Position',
        sort: 'Sorting',
        link: 'External Link',
        link_required: 'Please enter a link starting with http:// or https://',
        content: 'Introduction',
        content_required: 'Please enter the introduction',
        submit: 'Submit Now'
    },
    guest_list: {
        title: 'Guest List',
        delete_confirm: 'Are you sure you want to delete [{name}]?'
    },
    image_info: {
        title: 'Title',
        title_required: 'Please enter the title',
        image: 'Upload Image',
        image_required: 'Please upload an image',
        image_tips: 'Supports JPG, GIF, PNG image files. Recommended size: 900*500',
        link: 'Jump Link',
        link_required: 'Please enter a link starting with http:// or https://',
        submit: 'Submit Now',
        sort: 'Sorting',
        image_edit: 'Image Edit',
        image_text: 'Image',
        image_list: 'Image List'
    },
    nav_list_edit: {
        title: 'Navigation Menu Name',
        title_required: 'Please enter the column name',
        vice_title: 'Subtitle',
        is_system_icon: 'Use System Icon',
        is_system_icon_required: 'Please select whether to display',
        is_system_icon_yes: 'Yes',
        is_system_icon_no: 'No',
        select_system_icon: 'Please select a system icon',
        upload_image: 'Upload Image',
        upload_image_required: 'Please upload an image',
        upload_image_tips: 'Recommended size: 300*300. Supports JPG, GIF, PNG image files, and the file size should be less than 2M',
        clear_image: 'Clear',
        nav_bg_color: 'Navigation Background Color',
        nav_bg_color_required: 'Please select the navigation background color',
        nav_font_color: 'Navigation Font Color',
        nav_font_color_required: 'Please select the navigation font color',
        nav_font_size: 'Navigation Font Size',
        nav_font_size_required: 'Please select the navigation font size',
        tips: 'Note: You can configure transparency now',
        nav_type: 'Column Type',
        nav_type_required: 'Please select the column type',
        select_time: 'Select Time',
        select_time_required: 'Please select the time',
        content: 'Content',
        content_required: 'Please enter the content',
        nav_url: 'Jump Link',
        is_show_time: 'Show Time on Page',
        is_show_time_required: 'Please select whether to display',
        is_show_num: 'Show Page Views on Page',
        is_anonymous_msg: 'Allow Anonymous Messages',
        is_anonymous_msg_required: 'Please select whether to allow anonymous messages',
        sort: 'Sorting',
        sort_tips: 'Smaller values are displayed earlier',
        sort_required: 'Please enter the sorting value',
        submit: 'Submit Now',
        nav_list_edit: 'Column Edit',
        nav_list_add: 'Add New Column',
        upload_image_tips_news: '180*180px. Supports JPG, GIF, PNG image files'
    },
    show_hide: 'Show|Hide',
    create_time: 'Creation Time',
    news_list: 'News List',
    delete_confirm: 'Are you sure you want to delete this item?',
    welcome_page_image_tips: 'Recommended size: 1080*1700. Supports JPG, GIF, PNG image files, and the file size should be less than 1M. (Note: This image is displayed before the homepage is loaded)',
    default: 'Default'
};
